/**
 * Builds a stable origin string for an auto source detector.
 * Format: auto:<sourceType>:<eventType>:<sourceName>
 */
export function buildAutoSourceOrigin(
  sourceType: string,
  eventType: string,
  sourceName: string
): string {
  const safeName = sourceName.trim().replace(/\s+/g, '-') || 'unnamed';
  return `auto:${sourceType}:${eventType}:${safeName}`;
}
